import styled from "styled-components";
import {Col, Row, Select, Button, Input} from "antd";

export const CompanyContanier = styled.div`
    padding: 5px 20px 5px 20px;
    border: 1.5px solid #d9d9d9;
    border-radius: 2px;

    .ant-form-item {
        margin-top: 10px;
    }
    .ant-table-cell {
        padding: 5px 15px 5px 15px;
    }
`;

export const TableContainer = styled.div`
    padding: 5px 5px 5px 5px;
    border: 1.5px solid #d9d9d9;

    border-radius: 2px;

    .ant-form-item {
        margin-top: 10px;
    }
    .ant-table-cell {
        padding: 5px 10px 5px 10px;
    }
    margin-top: 10px;
`;

export const FilterContainer = styled(Row)`
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const SelectField = styled(Select)`
    width: 100%;
`;

export const SubCompanyContainer = styled.div`
    padding: 20px;
    border: 1.5px solid #d9d9d9;
    border-radius: 2px;
`;

export const CompanyButtonContainer = styled(Row)`
    padding: 16px;
`;

export const RadioContainer = styled.div`
    margin-top: 10px;
    margin-bottom: 10px;
`;

export const DeliveryType = styled.div`
    margin: 0 10px;
`;

export const DeliveryTypeItem = styled(Col)`
    margin: 0 10px;
`;

export const DeliveryTypeLabel = styled.h6`
    font-size: 12px;
`;

export const DeliveryTypeWarning = styled.span`
    color: red;
    font-size: 12px;
    margin-left: 10px;
`;

export const SlotDeleteButton = styled(Button)`
    display: flex;
    margin-bottom: 15px;
`;

export const IconCol = styled(Col)`
    margin: auto 0;
    color: #ffffff;
    font-size: 20px;
    background: #009688;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
`;

export const SlotCourierSelectField = styled(Select)`
    .ant-select-selection-item {
        height: auto !important;
    }
`;
